import { useSession } from '../../app/useSession';
import { useTeamMember } from '../../app/useTeamMember';
import {
  ROLE_LABELS,
  STATUS_LABELS,
  useCatalogTeam,
} from './catalogTeamQueries';
import styles from './settings.module.css';

export function CatalogTeamPage() {
  const session = useSession();
  const sessionObj = session.status === 'signed-in' ? session.session : null;
  const { data: teamMember } = useTeamMember(sessionObj);
  const orgId = teamMember?.organization_id ?? null;

  const { data: members = [], isLoading } = useCatalogTeam(orgId);

  return (
    <>
      <div className={styles.pageHead}>
        <h1>צוות והרשאות</h1>
        <p className={styles.pageSub}>חברי הארגון שלך עם תפקידים וסטטוסים. הזמנת חבר חדש זמינה ב-V1.1 (דורש Edge Function עם service-role).</p>
      </div>

      <div className={styles.card}>
        <div className={styles.cardHead}>
          <h3>חברי צוות ({members.length})</h3>
        </div>

        {isLoading ? (
          <p className={styles.notice}>טוען...</p>
        ) : members.length === 0 ? (
          <p className={styles.notice}>אין חברים עדיין.</p>
        ) : (
          <table className={styles.dataTable}>
            <thead>
              <tr>
                <th>שם</th>
                <th>תפקיד</th>
                <th>סטטוס</th>
                <th>הוזמן</th>
                <th>אושר</th>
              </tr>
            </thead>
            <tbody>
              {members.map((m) => (
                <tr key={m.id}>
                  <td>{m.full_name ?? <span className={styles.muted}>(אין שם)</span>}</td>
                  <td>{ROLE_LABELS[m.role] ?? m.role}</td>
                  <td>{STATUS_LABELS[m.status] ?? m.status}</td>
                  <td className={styles.muted}>
                    {m.invited_at ? new Date(m.invited_at).toLocaleDateString('he-IL') : '—'}
                  </td>
                  <td className={styles.muted}>
                    {m.accepted_at ? new Date(m.accepted_at).toLocaleDateString('he-IL') : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <p className={styles.notice} style={{ marginBlockStart: 'var(--space-3)' }}>
          ⓘ הזמנה ידנית של חבר חדש תוסיף ב-PR נפרד — דורש Edge Function שקורא ל-<code dir="ltr">supabase.auth.admin.inviteUserByEmail()</code>.
        </p>
      </div>
    </>
  );
}
